<template>
  <div>
    <!-- <Header /> -->
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex">
      <SideBar />

      <div class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926">
        <div class="px-5 lg:px-10 mt-10 pb-2">
          <router-link :to="{ name: 'InstructorAssignments' }"
            class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full">Back</router-link>
        </div>

        <div class="w-full px-5 lg:px-10">
          <div class="flex justify-end items-center">
            <div class="inline-flex rounded-full border border-gray-300 overflow-hidden">
              <button @click="setTab('list')" :class="[
                'px-6 py-2 flex items-center gap-1 transition-all duration-200',
                tab === 'list'
                  ? 'bg-blue-100 text-blue-600'
                  : 'bg-white text-gray-600',
              ]">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>

              <button @click="setTab('card')" :class="[
                'px-6 py-2 flex items-center gap-1 transition-all duration-200',
                tab === 'card'
                  ? 'bg-blue-100 text-blue-600'
                  : 'bg-white text-gray-600',
              ]">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="flex justify-between px-5 lg:px-10 py-2">
          <h1 class="text-lg font-bold whitespace-nowrap">
            Assignments Submitted
          </h1>
        </div>

        <div v-if="tab === 'list'" class=" pb-4">
          <div v-if="assignment_list != null" class="mt-5 space-y-4">
            <div class="w-full overflow-scroll border-b">
              <table class="min-w-full">
                <thead>
                  <tr class="text-left bg-[#18469d] text whitespace-nowrap text-sm">
                    <th class="px-6 py-3">Name</th>
                    <th class="px-6 py-3">Submitted at</th>
                    <th class="px-6 py-3">Submitted by</th>
                    <th class="px-6 py-3">Description</th>
                    <th class="px-6 py-3">Download</th>
                     <th class="px-6 py-3">Plagiarism Score</th>
                    <th class="px-6 py-3">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="assignment in assignment_list" :key="assignment" class="border-b pb-3 w-full">
                    <td class="px-6 py-3">
                      <!-- <img
                        class="w-20 h-16 object-cover rounded-md"
                        :src="require('@/assets/new/assignment.png')"
                        alt="Assignment"
                      /> -->
                      {{ assignment.title }}
                    </td>
                    <td class="px-6 py-3 whitespace-nowrap">
                      <p class="text-sm px-1">
                        {{ formatDate(assignment.created_at) || null }}
                      </p>
                    </td>
                    <td class="px-6 py-3 whitespace-nowrap">
                      <p class="text-sm px-1">
                        {{ assignment.user.display_name }}
                      </p>
                    </td>

                    <td class="px-6 py-3 md:!w-[250px]">
                      <p class="text-sm flex items-center gap-2">
                        <button @click.stop="openDescriptionModal(assignment.student_description)"
                          class="flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-600 rounded-md hover:bg-blue-200 transition-all"
                          title="View Full Description">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                          <span class="text-xs font-medium">View Description</span>
                        </button>
                      </p>

                    </td>
                    <td class="px-6 py-3 whitespace-nowrap">
                      <div>
                        <a :href="assignment.file" target="_blank">
                          <button class="bg-blues px-4 py-1.5 rounded-lg text-white font-semibold text-xs">
                            Submitted Document
                          </button>
                        </a>
                      </div>
                    </td>

                      <td class="px-6 py-3 text-gray-500">
                        <span v-if="assignment.plagiarismcheck != null && assignment.plagiarismcheck !=''">
                           {{ assignment.plagiarismcheck }}
                        </span>
                        <span v-else>
                           NA
                        </span>
                      </td>

                    <td class="px-6 py-3" @click="detailsPopup(assignment)">
                      <button v-if="assignment.verify_status == 'submitted'"
                        class="px-3 rounded-xl bg-sky-800 py-1.5 text-xs text-white font-semibold">
                        Submitted
                      </button>
                      <button v-else-if="assignment.verify_status == 'accepted'"
                        class="px-3 rounded-xl text-xs py-1.5 bg-teal-700 text-white font-semibold">
                        Accepted
                      </button>
                      <button v-else class="text-xs px-3 py-1.5 rounded-xl bg-pink-800 text-white font-semibold">
                        Rejected
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-else class="px-10">
            <div class="flex flex-col">
              <h1 class="text-sm text-gray-600">No Assignments Submitted</h1>
            </div>
          </div>
        </div>

        <div v-else-if="tab === 'card'" class="pb-4">
          <div v-if="assignment_list != null"
            class="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 px-5 lg:px-10 gap-10">
            <div v-for="assignment in assignment_list" :key="assignment" @click="detailsPopup(assignment)"
              class="flex flex-col gap-3 border p-5 rounded-xl">
              <img class="rounded-xl object-cover" src="@/assets/new/assignment.png" style="width: 100%" alt="" />

              <div class="flex flex-col gap-1 mt-2">
                <p class="text-sm px-1">
                  <span class="font-bold">Submitted at</span>
                  {{ formatDate(assignment.created_at) || null }}
                </p>
                <p class="text-sm px-1">
                  <span class="font-bold">Submitted by</span>
                  {{ assignment.user.display_name }}
                </p>
                <p class="text-sm px-1">
                  <span class="font-bold">Description:</span>
                  {{ assignment.student_description.slice(0, 160) }}
                </p>
                <div>
                  <a :href="assignment.file" target="_blank">
                    <button class="bg-blues px-4 py-1.5 rounded-lg text-white font-semibold text-xs">
                      Submitted Document
                    </button>
                  </a>
                </div>
              </div>

              <div class="flex mx-1 gap-3">
                <button v-if="assignment.verify_status == 'submitted'"
                  class="px-3 rounded-xl bg-sky-800 py-1.5 text-xs text-white font-semibold">
                  Submitted
                </button>
                <button v-else-if="assignment.verify_status == 'accepted'"
                  class="px-3 rounded-xl text-xs py-1.5 bg-teal-700 text-white font-semibold">
                  Accepted
                </button>
                <button v-else class="text-xs px-3 py-1.5 rounded-xl bg-pink-800 text-white font-semibold">
                  Rejected
                </button>
              </div>
            </div>
          </div>

          <div v-else class="px-10">
            <div class="flex flex-col">
              <h1 class="text-sm text-gray-600">No Assignments Submitted</h1>
            </div>
          </div>
        </div>

        <div v-if="is_detailsPopup"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center">
          <div class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px] w-[90%] mx-auto heightfix">
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-blues">Assignment</h3>
              <img src="@/assets/newd/close.png" class="cursor-pointer w-6" alt=""
                @click="(is_detailsPopup = false), (is_preview = false)" />
            </div>

            <div class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl">
              <div class="w-full">
                <div class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full">
                  <div class="flex flex-col w-full gap-2">
                    <p class="text-sm font-semibold">Title</p>
                    <p class="text-sm">{{ assignmentDetails.title }}</p>
                  </div>
                  <div class="flex flex-col w-full gap-2">
                    <p class="text-sm font-semibold">Description</p>
                    <p class="text-sm">
                      {{ assignmentDetails.student_description }}
                    </p>
                  </div>

                  <div>
                    <a :href="assignmentDetails.file" target="_blank">
                      <button class="bg-blues px-4 py-1.5 rounded-lg text-white font-semibold text-xs">
                        Download Submitted Document
                      </button>
                    </a>
                  </div>

                  <div v-if="assignmentDetails.verify_status == 'submitted'" class="flex gap-4">
                    <div
                      class="flex justify-arround gap-2 rounded-2xl cursor-pointer hover:text-white text-white bg-green-900 w-auto py-1.5 px-4 items-center"
                      @click="open_accept_pop = true">
                      <font-awesome-icon class="text-sm self-center" :icon="['fas', 'check-circle']" />
                      <p class="text-xs hover:text-white">Accept</p>
                    </div>
                    <div
                      class="flex justify-arround gap-2 rounded-2xl text-white cursor-pointer hover:text-white font-bold bg-red-700 w-auto py-1.5 text-xs px-4 items-center"
                      @click="open_rejected_pop = true">
                      <font-awesome-icon class="text-sm self-center" :icon="['fas', 'times-circle']" />
                      <p class="text-xs">Reject</p>
                    </div>
                  </div>

                  <div v-else class="flex flex-col gap-2">
                    <h1 class="text-base font-bold">Already validated</h1>
                    <p class="capitalize text-sm font-semibold">
                      Status :
                      <span :class="[
                        assignmentDetails.verify_status == 'rejected'
                          ? 'text-red-700'
                          : 'text-green-700',
                      ]">
                        {{ assignmentDetails.verify_status }}
                      </span>
                    </p>

                    <div>
                      <span class="capitalize text-sm font-semibold">Remark / Grade: </span> {{ assignmentDetails.remark }}
                    </div>

                  </div>

                  <!-- <vue-pdf-embed :source="convertHttpToHttps(assignmentDetails.file)" class="w-full h-[100px]" /> -->

                  <!-- <div class="flex justify-end pb-4 mt-3">
                    <button
                      type="submit"
                      class="text-black border border-black rounded-lg text-sm px-10 py-2"
                    >
                      Submit
                    </button>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.open_rejected_pop == true || this.open_accept_pop == true"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center">
      <div class="lg:w-[30%] bg-white rounded-xl p-5 overflow-y-auto max-h-[600px]">
        <div class="flex items-center justify-center">
          <h3 v-if="open_accept_pop" class="text-xl font-bold text-blues text-center">
            Accepted
          </h3>
          <h3 v-if="open_rejected_pop" class="text-xl font-bold text-blues text-center">
            Rejected
          </h3>
        </div>

        <div class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl">
          <div class="w-full">
            <form ref="createTeamRef" @submit.prevent="submitResult"
              class="flex flex-col gap-2 text-xs md:text-sm lg:text-base h-full">
              <div v-if="open_accept_pop" class="w-full flex flex-col gap-2">
                <label for="grade" class="flex items-center text-left text-sm font-medium text-gray-700 gap-1">
                  <span>Grade</span>
                  <div class="relative group">
                    <svg xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer" fill="currentColor"
                      viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                        clip-rule="evenodd" />
                    </svg>
                    <div
                      class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2">
                      Provide a grade
                    </div>
                  </div>
                </label>

                <input required id="grade" v-model="grade" type="text" placeholder="Enter grade"
                  class="border border-gray-200 rounded text-xs md:text-sm lg:text-base py-2 px-2" />
              </div>
              <div v-if="open_rejected_pop" class="w-full flex flex-col gap-2">
                <label for="grade" class="flex items-center text-left text-sm font-medium text-gray-700 gap-1">
                  <span>Remarks</span>
                  <div class="relative group">
                    <svg xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer" fill="currentColor"
                      viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                        clip-rule="evenodd" />
                    </svg>
                    <div
                      class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2">
                      Provide a remark
                    </div>
                  </div>
                </label>

                <input required id="remark" type="text" v-model="remarks" placeholder="Enter Remarks"
                  class="border border-gray-200 rounded text-xs md:text-sm lg:text-base py-2 px-2" />
              </div>

              <div class="flex justify-center pb-4 mt-3 gap-10">
                <button @click="
                  this.open_rejected_pop = false;
                this.open_accept_pop = false;
                " class="border text-gray-500 rounded-lg text-sm px-5 lg:px-10 font-semibold py-2">
                  Close
                </button>
                <div class="flex gap-3 items-center">
                  <button type="submit" :disabled="disable_submit == true" :class="this.disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                    " class="rounded-lg text-sm px-5 lg:px-10 font-semibold py-2">
                    Submit
                  </button>
                  <img v-if="disable_submit" src="@/assets/loading.gif" alt="loading" class="w-6 h-6 object-contain" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="descriptionModalOpen"
    class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4">
    <div class="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-hidden flex flex-col relative">
      <!-- Modal Header -->
      <div class="flex items-center justify-between p-5 border-b border-gray-200">
        <h2 class="text-xl font-semibold text-gray-800">Assignments Submitted Description</h2>
        <button @click="descriptionModalOpen = false" class="text-gray-500 hover:text-red-500 text-2xl">
          &times;
        </button>
      </div>
      <!-- Modal Body -->
      <div class="p-6 overflow-y-auto text-gray-700 text-sm leading-relaxed whitespace-pre-wrap">
        {{ currentDescription }}
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import VuePdfEmbed from "vue-pdf-embed";

export default {
  components: {
    Header,
    SideBar,
    VuePdfEmbed,
    FlashMessage,
  },
  data() {
    return {
      descriptionModalOpen: false,
      currentDescription: "",
      assignment_list: "",
      is_detailsPopup: false,
      assignmentDetails: null,
      messages: {
        text: "",
        type: "null",
      },
      is_preview: false,
      open_accept_pop: false,
      open_rejected_pop: false,
      grade: "",
      remarks: "",
      tab: "list",
      disable_submit: false,
    };
  },
  created() {
    this.getdetails();
  },

  props: ["course_id", "assignment_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    openDescriptionModal(description) {
      this.currentDescription = description;
      this.descriptionModalOpen = true;
    },
    showMore(index) {
      this.assignmentInfo.data[index].visibleLengths += 50;
    },
    showLess(index) {
      // this.assignmentInfo.data[index].visibleLengths -= 100;
      this.assignmentInfo.data[index].visibleLengths = 50;
    },
    setTab(view) {
      this.tab = view;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    convertHttpToHttps(url) {
      if (url.startsWith("http://")) {
        return url.replace("http://", "https://");
      }
      return url; // If it's already https or any other scheme, return as is
    },
    submitResult() {
      if (this.open_accept_pop) {
        this.accept();
      } else if (this.open_rejected_pop) {
        this.reject();
      }
    },
    accept() {
      this.disable_submit = true;
      let acceptsVal = {
        user: this.assignmentDetails.user.id,
        assignment_id: this.assignmentDetails.assignment_id,
        title: this.assignmentDetails.title,
        student_description: this.assignmentDetails.student_description,
        submit_date: this.assignmentDetails.submit_date,
        verify_status: "accepted",
        remark: this.grade,
      };

      axios
        .put(
          `${process.env.VUE_APP_API}/student_assignment/updated/${this.assignmentDetails.id}/?Key=${this.userInfo.token_key}`,
          acceptsVal
        )
        .then((response) => {
          console.log(response);
          if (
            response.data.message == "Student Assignment updated successfully"
          ) {
            this.messages = {
              text: "Assignment Accepted successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.is_detailsPopup = false;
        this.open_accept_pop = false;
        this.disable_submit = false;
        this.getdetails();
      }, 1500);
    },

    reject() {
      this.disable_submit = true;
      let rejectedVal = {
        user: this.assignmentDetails.user.id,
        assignment_id: this.assignmentDetails.assignment_id,
        title: this.assignmentDetails.title,
        student_description: this.assignmentDetails.student_description,
        submit_date: this.assignmentDetails.submit_date,
        verify_status: "rejected",
        remark: this.remarks,
      };

      axios
        .put(
          `${process.env.VUE_APP_API}/student_assignment/updated/${this.assignmentDetails.id}/?Key=${this.userInfo.token_key}`,
          rejectedVal
        )
        .then((response) => {
          console.log(response);
          if (
            response.data.message == "Student Assignment updated successfully"
          ) {
            this.messages = {
              text: "Assignment Rejected",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.is_detailsPopup = false;
        this.open_rejected_pop = false;
        this.disable_submit = false;
        this.getdetails();
      }, 1500);
    },

    detailsPopup(value) {
      this.is_detailsPopup = true;
      this.assignmentDetails = value;
    },

    async getdetails() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/assignment/list/view/?assignment_id=${this.assignment_id}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          console.log(response);
          if (response.data.message == "No details found") {
            console.log("Null");
            this.assignment_list = null;
          } else {
            this.assignment_list = response.data;

            console.log("this.assignment_list", this.assignment_list);
            // this.assignment_list.data.forEach((element) => {
            //   console.log(element.title);
            //   element["display_date"] = new Date(
            //     element.submit_date
            //   ).toLocaleDateString("en-IN", {
            //     day: "numeric",
            //     month: "long",
            //     year: "numeric",
            //   });
            // });

            this.assignment_list = this.assignment_list.data;
          }
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
